import React, {useEffect, useState} from "react";
import Form from 'react-bootstrap/Form';
import './DataConnector.css';
import { Button} from 'rsuite';
import { List } from 'rsuite';
import { get, post } from "../../utils/API";
import { API_URL } from "../../utils/API";
import Spin from './Spin.svg';
import { useDispatch, useSelector } from "react-redux";
import { sqlActions } from "../../Redux/sql";

export default function DataConnector({sql, setSql}) {
    const sqlInfo = useSelector((state) => state.sql)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [fetchingTables, setFetchingTables] = useState(false)

    async function getTables() {
        dispatch(sqlActions.updateTables(null))
        setFetchingTables(true)
        setLoading(true)
        try {
            let response = await post(`${API_URL}/get-tables`, sqlInfo)
            dispatch(sqlActions.updateTables(response.tables))
            dispatch(sqlActions.updateColumnHeaders(response.columnHeaders))
            localStorage.setItem("username", sqlInfo.username)
            localStorage.setItem("password", sqlInfo.password)
            localStorage.setItem("host", sqlInfo.host)
            localStorage.setItem("port", sqlInfo.port)
            localStorage.setItem("database", sqlInfo.database)
            localStorage.setItem("databaseDriver", sqlInfo.databaseDriver)
        } catch {
            setLoading(false)
        }
        setLoading(false)
        setFetchingTables(false)
    }

   function onUsernameChange(e) {
    dispatch(sqlActions.updateUsername(e.target.value))
   }

   function onPasswordChange(e) {
    dispatch(sqlActions.updatePassword(e.target.value))
   }

   function onHostChange(e) {
    dispatch(sqlActions.updateHost(e.target.value))
   }

   function onDatabaseChange(e) {
    dispatch(sqlActions.updateDatabase(e.target.value))
   }

   async function checkTable(table) {
    dispatch(sqlActions.updateTables(sqlInfo.tables.map(current => {
        if (current === table) {
            let tableName = current.tableName
            dispatch(sqlActions.updateTableName(tableName))
            return {...current, selected: true}
        } 
        return {...current, selected: false}
    })))
    }

    useEffect(() => {console.log(sqlInfo)})

    return (
        <div className="background">
            <button type="button" class="btn-close btn-close-white" aria-label="Close" onClick={() => setSql(false)}></button>
            <div className="container-fluid modal-container">
                <div className="row">
                    <div className="col-6">
                    <div className=" p-5">
                
                {sqlInfo.databaseDriver === "mysql" ? <Button onClick={() => dispatch(sqlActions.updateDatabaseDriver("mysql"))} appearance="primary" color="cyan"><img src="https://img.icons8.com/fluency/512/mysql-logo.png" alt="" width={50} height={50}/>MySQL</Button> : <Button onClick={() => dispatch(sqlActions.updateDatabaseDriver("mysql"))}><img src="https://img.icons8.com/fluency/512/mysql-logo.png" alt="" width={50} height={50}/>MySQL</Button>} 
                {sqlInfo.databaseDriver === "postgresql" ?  <Button onClick={() => dispatch(sqlActions.updateDatabaseDriver("postgresql"))} appearance="primary" color="cyan"><img src="https://img.icons8.com/color/512/postgreesql.png" alt="" width={50} height={50}/> PostgreSQL</Button> :  <Button onClick={() => dispatch(sqlActions.updateDatabaseDriver("postgresql"))}><img src="https://img.icons8.com/color/512/postgreesql.png" alt="" width={50} height={50}/> PostgreSQL</Button>}
               
                
                </div>
                <div className="row">
                <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>Host</Form.Label>
                      <Form.Control type="text" placeholder="0.0.0.0" onChange={(e) => onHostChange(e)} value={sqlInfo.host}/>
                    </Form.Group>
 
                    {sqlInfo.databaseDriver === "postgresql" &&
                    <Form.Group className="mb-3">
                      <Form.Label>Port</Form.Label>
                      <Form.Control type="number" placeholder="5432" onChange={(e) => dispatch(sqlActions.updatePort(parseInt(e.target.value)))} value={sqlInfo.port}/>
                    </Form.Group>
                    
                    }

                    <Form.Group className="mb-3">
                      <Form.Label>Username</Form.Label>
                      <Form.Control type="text" placeholder="Enter Username" onChange={(e) => onUsernameChange(e)} value={sqlInfo.username}/>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control type="password" placeholder="Enter Password" onChange={(e) => onPasswordChange(e)} value={sqlInfo.password}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Database</Form.Label>
                      <Form.Control type="text" placeholder="Enter Database Name" onChange={(e) => onDatabaseChange(e)} value={sqlInfo.database}/>
                    </Form.Group>

                    <div className="text-center">
                        <Button color="blue" appearance="primary" loading={loading} onClick={() =>  getTables()}>Connect</Button>
                    </div>
                </Form>
            </div>
                    </div>

                    <div className="col-6">
                    <div className="modal-container p-5">
                        <h3>Tables</h3>
               
                            {sqlInfo.tables ? 
                            <div className="tables">
                                <List hover>
                                    {sqlInfo.tables.map(table => {
                                        return (
                                            <div onClick={() => checkTable(table)} className="table">
                                                <List.Item>{table.tableName} {table.selected ? <img src="https://img.icons8.com/flat-round/20/null/checkmark.png"/> : null}</List.Item>
                                            </div>
                                        )
                                        
                                        
                                    })}
                                </List>
                            </div>
                           
                        : 
                        fetchingTables ?   <div className="container-fluid">
                                    <div className="row justify-content-center">
                                        <img src={Spin} style={{width: 200, height: 200}}/>
                                    </div>
                                
                            </div> :null 
                      
                    }
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}